import { dateFormat, currencySymbol } from 'filters'
import pagination from 'components/pagination'
import { funcModal, reservationDetails } from 'components/modals'
import { hasPermits } from 'directives'
import layout from 'layouts/default'
import datepicker from 'components/datepicker'
import timepicker from 'components/timepicker'
import sSelect from 'components/sSelect'
import moment from 'moment'

const directives = {
  hasPermits
}

const components = {
  layout,
  pagination,
  reservationDetails,
  funcModal,
  datepicker,
  timepicker,
  sSelect,
}

const filters = {
  dateFormat,
  currencySymbol
}

const computed = {
  reservations () {
    return _.cloneDeep(this.$store.state.reservations.all);
  },

  locations () {
    let locations = _.cloneDeep(this.$store.state.locations.all);
    return _.map(locations, item => {
      return {
        value: item.id,
        text: item.name
      }
    });
  },
}

const methods = {
  loadPage (page = 1) {
    this.errors = {};
    this.$route.query.page = page;
    this.loading = true;
    let params = {
      page,
      mode: this.filters.mode,
      search_by: this.filters.search_by,
      'reservation_number-lk': this.filters.search ? this.filters.search_by == 'reservation_number' ? "*" + this.filters.search.trim() + "*" : this.filters.search.trim() : null,
    }
    if (this.show_advanced_search) {
      if (this.filters.from_date) {
        if (moment(this.filters.from_date).isValid() && this.filters.from_time) {
          params.from_date = moment(`${this.filters.from_date} ${this.filters.from_time}`).format('YYYY-MM-DD HH:mm:ss');
        } else {
          params.from_date = moment(this.filters.from_date, ['MM/DD/YYYY']).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        }
      }
      if (this.filters.to_date) {
        if (moment(this.filters.to_date).isValid() && this.filters.to_time) {
          params.to_date = moment(`${this.filters.to_date} ${this.filters.to_time}`).format('YYYY-MM-DD HH:mm:ss');
        } else {
          params.to_date = moment(this.filters.to_date, ['MM/DD/YYYY']).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        }
      }
      if (this.selectedLocation) {
        params.location_id = this.selectedLocation.value;
      }
      if (this.selectedTypes.length) {
        params.parking_types = this.selectedTypes.filter(type => type.value.includes('parking')).map((type) => {
          return Number(type.value.replace('parking-', ''));
        });
        params.room_types = this.selectedTypes.filter(type => type.value.includes('room')).map((type) => {
          return Number(type.value.replace('room-', ''));
        });
        params.bundle_types = this.selectedTypes.filter(type => type.value.includes('bundle')).map((type) => {
          return Number(type.value.replace('bundle-', ''));
        });
      }
    }
    return this.$store.dispatch('reservations.getReservations', {
      params: params
    }).then(() => {
      this.loading = false;
      let errors = _.cloneDeep(this.$store.state.reservations.errors);
      if (errors) {
        this.errors = errors.errors;
      }
    });
  },

  loadReservation (item) {
    this.$set(this.loadings, item.id, true);
    this.$store.dispatch('reservations.get', item.id).then(() => {
      this.$set(this.loadings, item.id, false);
      this.activeReservation = _.cloneDeep(this.$store.state.reservations.active);
      this.$nextTick(() => {
        this.$refs.reservationDetailsModal.open();
      })
    })
  },

  currencyCode(location) {
    return location.currency ? currencySymbol(location.currency.code) : "Na";
  },

  openFeesBreakDown (channel_id, reservation_id) {
    this.fees_loading = true;
    this.fees_breakdown = [];
    this.$refs.feesBreakDown.open();
    this.$store.dispatch('channels.getReservationFees', {channel_id, reservation_id}).then(() => {
      this.fees_breakdown = this.$store.state.channels.active.fees_breakdown;
      this.fees_loading = false;
    });
  },

  search (searchKey) {
    this.filters.search = searchKey;
    this.loadPage(1);
  },

  onChangeSelectedLocation (location) {
    this.selectedLocation = location;
    let promises = [
      this.$store.dispatch('locations.get', {id: location.value}),
      this.$store.dispatch('locations.parkingTypes', {id: location.value}),
      this.$store.dispatch('locations.roomTypes', {id: location.value}),
      this.$store.dispatch('locations.bundleTypes', {id: location.value}),
    ];

    Promise.all(promises).then(() => {
      let parking_types = _.cloneDeep(this.$store.state.locations.active.parkingTypes);
      let room_types = _.cloneDeep(this.$store.state.locations.active.roomTypes);
      let bundle_types = _.cloneDeep(this.$store.state.locations.active.bundleTypes);
      let location_types = [];

      parking_types.forEach((item) => {
        location_types.push({type: 'parking', item: item});
      });
      room_types.forEach((item) => {
        location_types.push({type: 'room', item: item});
      });
      bundle_types.forEach((item) => {
        location_types.push({type: 'bundle', item: item});
      });

      this.locationTypes = _.map(location_types, item => {
        return {
          value: item.type + '-' + item.item.id,
          text: item.item.name
        }
      });
    });

  },

  onChangeSelectedTypes (types) {
    this.selectedTypes = types;
  },
}

const watch = {
  locationTypes (n, o) {
    if (n == o) return;
  },

  show_advanced_search (n, o) {
    if (n == o) return;
    if (n == false) {
      this.filters.from_date =  null;
      this.filters.from_time = null;
      this.filters.to_date = null;
      this.filters.to_time = null;
      this.selectedLocation = {},
      this.selectedTypes = [];
    }
  }
}

export default {
  name: 'reservations',
  directives,
  components,
  computed,
  methods,
  filters,
  watch,
  data () {
    return {
      loading: false,
      activeReservation: null,
      loadings: {},
      fees_breakdown: [],
      fees_loading: false,
      show_advanced_search: false,
      filters: {
        search: null,
        mode: 'all',
        search_by: 'reservation_number',
        from_date: null,
        to_date: null,
        from_time: null,
        to_time: null,
      },
      selectedLocation: {},
      locationTypes: [],
      parkingTypes: [],
      roomTypes: [],
      bundleTypes: [],
      selectedTypes: [],
      errors: {},
    }
  },
  created () {
    this.loadPage(this.$route.query.page || 1);
  },

  mounted () {
    this.$store.dispatch('locations.getAll', {_q: "", _all: true})
  }
}
